import { Directive, HostListener, Input, EventEmitter, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';
import { FeatureListJsonService } from '../services/config-manager/feature-list/feature-list-json.service';
import { AppSelectorService } from '../services/app-selector/app-selector.service';

@Directive({
  selector: '[appDisableFeature]'
})
export class DisableFeatureDirective implements OnInit {
  @Input() pathString: string = '';
  @Input() callbackFromDirective: any = null;
  private flagValue;
  private handlerFunction: any;
  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private featureListJsonService: FeatureListJsonService,
    private appSelectorService: AppSelectorService) {
    this.init = this.init.bind(this);
    this.update = this.update.bind(this);
    this.clickCallback = this.clickCallback.bind(this);
  }

  ngOnInit() {
    if (!this.pathString) {
      return;
    }
    this.featureListJsonService.shouldEnableTheFeature(this.pathString, 'disabled', this.init);
    this.addAppChangeListener();
  }

  addAppChangeListener() {
    this.appSelectorService.getAppChangedListener().subscribe((selectedApp) => {
      if (typeof this.flagValue === 'undefined') {
        return;
      }
      this.featureListJsonService.shouldEnableTheFeature(this.pathString, 'disabled', this.update);
    });
  }

  update(flag) {
    if (this.flagValue === flag) {
      return;
    }
    this.flagValue = flag;
    if (this.flagValue) {
      this.init(this.flagValue);
      return;
    }
    this.renderer.removeClass(this.element.nativeElement, 'feature-disabled');
    if (this.handlerFunction) {
      let el: any = this.element.nativeElement;
      el.removeAllListeners('click');
      el.addEventListener('click', this.handlerFunction);
    }
  }

  init(flag) {
    this.flagValue = flag;
    if (!flag) {
      return;
    }
    const el: any = this.element.nativeElement;
    const clickHandlers = el.eventListeners('click');
    if (clickHandlers && clickHandlers.length) {
      this.handlerFunction = clickHandlers[0];
    }
    el.removeAllListeners('click');
    el.addEventListener('click', this.clickCallback);
    this.renderer.addClass(this.element.nativeElement, 'feature-disabled');
  }

  getFeatureNameFromPathString(path) {
    if (!path) {
      return '';
    }
    let splitter = path.split('.');
    if (!splitter.length) {
      return '';
    }
    return splitter[splitter.length - 1];
  }

  clickCallback(flag) {
    if (!flag) {
      return;
    }
    if (this.callbackFromDirective) {
      let featureName = this.getFeatureNameFromPathString(this.pathString);
      this.callbackFromDirective(featureName);
    }
    event.preventDefault();
    event.stopPropagation();
  }
}
